<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-arrow-left-right"></i>
              Transferencia
            </h6>
            <button type="button" class="form-card__btn" @click="modified">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">

            <div
              v-if="limited && header.pos != 0 && total >= 500000 && (header.letter === 'C' || header.letter === 'B')"
              class="alert alert-danger mb-3">
              Record&aacute; que para realizar una factura mayor a $ 500.000 ten&eacute;s que informar a la AFIP todos los datos del cliente.
            </div>

            <!-- SUMMARY -->
            <div class="transfer-summary">
              <div class="total-row total-final">
                <span class="label">Total a pagar</span>
                <span class="value">$ {{ round(total, 2) }}</span>
              </div>
              <div class="total-row">
                <span class="label">Transferencia</span>
                <span class="value">$ {{ totalTransfer }}</span>
              </div>
              <div v-if="limited && diference != 0" class="total-row">
                <span class="label">Diferencia</span>
                <span class="value text-danger">$ {{ round(diference, 2) }}</span>
              </div>
            </div>

            <div class="totals-divider"></div>

            <!-- TRANSFER FORM -->
            <div class="form-row">
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Transferencia</label>
                <input
                  v-model.number="transfer"
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control"
                  @input="updateBanks">
              </div>
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Caja banco destino</label>
                <div class="transfer-form__select">
                  <select
                    v-model="fundTransfer"
                    class="form-control"
                    name="fund_id"
                    @change="updateBanks">
                    <option disabled value="0">Seleccione una caja...</option>
                    <option v-for="fundBank in fundsBank" :key="fundBank.id" :value="fundBank.id">{{fundBank.name}}</option>
                  </select>
                  <button type="button" class="btn btn-primary transfer-form__add" title="Agregar otra transferencia" @click="addInputSelect">
                    <i class="bi bi-plus-lg"></i>
                  </button>
                </div>
              </div>
            </div>

            <div v-for="(inputSelect, index) in inputSelects" :key="index" class="form-row mt-2">
              <div class="form-group col-md-6 mb-2">
                <input
                  v-model.number="inputSelect.input"
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control"
                  placeholder="0"
                  @input="updateBanks">
              </div>
              <div class="form-group col-md-6 mb-2">
                <div class="transfer-form__select">
                  <select
                    v-model="inputSelect.select"
                    class="form-control"
                    name="fund_id"
                    @change="updateBanks">
                    <option v-for="fundBank in fundsBank" :key="fundBank.id" :value="fundBank.id">{{fundBank.name}}</option>
                  </select>
                  <button type="button" class="btn btn-outline-danger transfer-form__remove" title="Quitar esta transferencia" @click="removeInputSelect(index)">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>

          </div>

          <div class="form-card__footer">
            <button v-if="limited" type="button" class="form-card__btn" @click="modified">Cancelar</button>
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="!(round(diference, 2) == 0) || (limited == 0) || !cajasTransferValidas"
              @click="finishReceipt">
              <i class="bi bi-check-lg"></i>
              Finalizar venta
            </button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['total', 'paymentMethods', 'header', 'limited', 'fundDefault', 'genType'],
  data: function() {
    return {
      totalpayed: 0,
      diference: 0,
      payarray: {
        banks:[],
        cash: 0,
        fund_id: 0,
        fundBanks_id: [],
        accounts: [],
        creditcards: [],
        tpchecks: []
      },
      inputSelects: [],
      transfer: 0,
      fundTransfer: 0,
      totalTransfer: 0,
    }
  },
  mounted: function () {
    this.payarray.fund_id = this.fundDefault;
    this.transfer = this.total;

    this.getFunds();
    this.calc();
  },
  computed: {
      ...mapGetters({
        fundsBank: 'funds/bankFunds'
      }),
      banks: {
          get: function () {
              return this.payarray.banks;
          },
          set: function (value) {
              if (value==''){
                  this.transfer = 0;
              }else{
                  this.transfer = value;
              }
          }
      },
      // Toda línea de transferencia con monto > 0 debe tener una caja elegida
      // (no la opción "Seleccione una caja..."). Bloquea el cierre si falta.
      cajasTransferValidas: function () {
        if (this.transfer > 0 && !this.fundTransfer) return false;
        for (var i = 0; i < this.inputSelects.length; i++) {
          if (this.inputSelects[i].input > 0 && !this.inputSelects[i].select) return false;
        }
        return true;
      },
  },
  watch: {
    payarray: {
      handler: function () {
        this.calc();
      }, deep: true
    }
  },
  methods: {
    round: function(value, decimals) {
      return (Number(Math.round(value + 'e' + decimals) + 'e-' + decimals));
    },
    updateBanks() {
      const banks = [{ amount: this.transfer }];
      const fundTransfer = [{fund: this.fundTransfer}];
      const inputSelectsBanks = this.inputSelects.map(select => ({
        amount: select.input,
      }));

      const selectSelectsBanks = this.inputSelects.map(select => ({
        fund: select.select,
      }));
      this.payarray.fundBanks_id = fundTransfer.concat(selectSelectsBanks);
      this.payarray.banks = banks.concat(inputSelectsBanks);
      console.log(this.payarray.fundBanks_id);
      this.calcTotalTransfer();
    },

    addInputSelect() {
      this.inputSelects.push({ input: 0, select: '' });
      console.log(this.inputSelects.length);
    },
    removeInputSelect(index) {
      this.inputSelects.splice(index, 1);
      this.updateBanks();
    },
    calcTotalTransfer() {
      this.totalTransfer = this.payarray.banks.reduce((sum, bank) => sum + bank.amount, 0);
    },
    calc: function () {
      this.totalpayed = 0;

      if(this.payarray.cash==''){
        this.payarray.cash = 0;
      }

      var totalbanks = this.totalTransfer;

      this.totalpayed = this.round(totalbanks,2);
      this.diference = this.round(this.total,2) - this.round(this.totalpayed,2);
    },

    fromdateUpdated: function (date) {
      this.header.service_fromdate = date;
    },
    modified: function () {
      this.$emit('paymentmethodschanged',{});
      this.$emit('close');
    },
    finishReceipt: function () {
      this.$emit('paymentmethodsclose',this.payarray);
      this.$emit('close');
    },
    ...mapActions({
      getFunds: 'funds/getFunds'
    })
  },
}
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 720px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.transfer-form__select {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.transfer-form__add,
.transfer-form__remove {
  flex-shrink: 0;
  width: 42px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
